import { render, staticRenderFns } from "./ClientDocument.vue?vue&type=template&id=45d84273&"
import script from "./ClientDocument.vue?vue&type=script&lang=js&"
export * from "./ClientDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports